/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Booking_Status_ConfirmedInputs */

const en_rental_booking_status_confirmed = /** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking Confirmed`)
};

const es_rental_booking_status_confirmed = /** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva Confirmada`)
};

const fr_rental_booking_status_confirmed = /** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservation confirmée`)
};

const de_rental_booking_status_confirmed = /** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchung bestätigt`)
};

const id_rental_booking_status_confirmed = /** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemesanan Dikonfirmasi`)
};

/** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */
const ja_rental_booking_status_confirmed = en_rental_booking_status_confirmed;

/** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */
const zh_rental_booking_status_confirmed = en_rental_booking_status_confirmed;

/** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */
const ar_rental_booking_status_confirmed = en_rental_booking_status_confirmed;

/** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */
const it_rental_booking_status_confirmed = en_rental_booking_status_confirmed;

/** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */
const ru_rental_booking_status_confirmed = en_rental_booking_status_confirmed;

/** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */
const pt_rental_booking_status_confirmed = en_rental_booking_status_confirmed;

/** @type {(inputs: Rental_Booking_Status_ConfirmedInputs) => LocalizedString} */
const ko_rental_booking_status_confirmed = en_rental_booking_status_confirmed;

/**
* | output |
* | --- |
* | "Booking Confirmed" |
*
* @param {Rental_Booking_Status_ConfirmedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_booking_status_confirmed = /** @type {((inputs?: Rental_Booking_Status_ConfirmedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Booking_Status_ConfirmedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_booking_status_confirmed(inputs)
	if (locale === "es") return es_rental_booking_status_confirmed(inputs)
	if (locale === "fr") return fr_rental_booking_status_confirmed(inputs)
	if (locale === "de") return de_rental_booking_status_confirmed(inputs)
	if (locale === "ja") return ja_rental_booking_status_confirmed(inputs)
	if (locale === "zh") return zh_rental_booking_status_confirmed(inputs)
	if (locale === "ar") return ar_rental_booking_status_confirmed(inputs)
	if (locale === "id") return id_rental_booking_status_confirmed(inputs)
	if (locale === "it") return it_rental_booking_status_confirmed(inputs)
	if (locale === "ru") return ru_rental_booking_status_confirmed(inputs)
	if (locale === "pt") return pt_rental_booking_status_confirmed(inputs)
	return ko_rental_booking_status_confirmed(inputs)
});